import styled from 'styled-components';
import Label from '../Label';

export const StyledDetailLabel = styled(Label)`
  padding-bottom: 6px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

export const StyledDetailValue = styled(Label)`
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
`;
